import React from 'react';
import { createRoot } from 'react-dom/client';
import CaptchaAudioButton from './CaptchaAudioButton';
window.mountCaptchaAudioButton = function mountCaptchaAudioButton(containerId, props = {}) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('CaptchaAudioButton: container not found:', containerId);
        return { type: 'captcha-audio-button', unmount: () => { } };
    }
    const root = createRoot(container);
    root.render(React.createElement(CaptchaAudioButton, props));
    return {
        type: 'captcha-audio-button',
        unmount: () => root.unmount(),
    };
};
